<template>
  <div class="my-5 mx-4">
    <div>
      <h1 class="text-center font-weight-light">
        {{ userCompany }} New Hire Documents
      </h1>
      <p class="text-center caption">
        These documents need to be filled out before you're able to be scheduled
      </p>
    </div>

    <v-card class="pa-4" outlined flat>
      <v-card-actions>
        <v-row align="center" justify="end">
          <v-btn small color="success" dark class="mr-1">
            generate pdf
          </v-btn>
          <v-btn small color="primary" dark>
            save changes
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-card>
      <v-stepper
        v-model="e1"
        elevation-0
        :alt-labels="!$vuetify.breakpoint.xs"
        @change="onChangeTab"
      >
        <v-stepper-header>
          <template v-for="(n, i) in stepperHeader">
            <v-stepper-step
              class="text-caption "
              :key="`${n}-step`"
              :complete="e1 > i + 1"
              :step="i + 1"
              editable
            >
              <div class="text-center">
                {{ n }}
              </div>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <RuleAgreement
              v-if="e1 === 1"
              title="18/6 Rule Agreement"
              @clicked="onChangeTab"
              :currentStep="1"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="2">
            <AcknowledgementOfContractUnderstanding
              v-if="e1 === 2"
              title="Acknowledgement of Contract Understanding"
              @clicked="onChangeTab"
              :currentStep="2"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <AcknowledgementOfEmployeeHandbook
              v-if="e1 === 3"
              title="Acknowledgement of Receipt of Employee Handbook"
              @clicked="onChangeTab"
              :currentStep="3"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="4">
            <AcknowledgementOfPolisophedureManual
              v-if="e1 === 4"
              title="Acknowledgement of Receipt of Polisophedure Manual"
              @clicked="onChangeTab"
              :currentStep="4"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="5">
            <AwakePolicy
              v-if="e1 === 5"
              title="Awake Policy"
              @clicked="onChangeTab"
              :currentStep="5"
              :user="user"
            />
          </v-stepper-content>


          <v-stepper-content step="6">
            <CompanyHealthWellnessDentalAndVision
              v-if="e1 === 6"
              title="Company Health Wellness, Dental and Vision"
              @clicked="onChangeTab"
              :currentStep="6"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="7">
            <RedheadSupportsJobDescription
              v-if="e1 === 7"
              title="Redhead Supports Job Description"
              @clicked="onChangeTab"
              :currentStep="7"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="8">
            <FraternizationPolicy
              v-if="e1 === 8"
              title="Fraternization Policy "
              @clicked="onChangeTab"
              :currentStep="8"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="9">
            <ExtremeBehaviorAwareness
              v-if="e1 === 9"
              title="Extreme Behavior Awareness"
              @clicked="onChangeTab"
              :currentStep="9"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="10">
            <ClientTransportation
              v-if="e1 === 10"
              title="Client Transportation Agreement"
              @clicked="onChangeTab"
              :currentStep="10"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="11">
            <ConfirmationExtended
              v-if="e1 === 11"
              title="Confirmation of Extended Service Funding"
              @clicked="onChangeTab"
              :currentStep="11"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="12">
            <ConfirmationStability
              v-if="e1 === 12"
              title="Confirmation of Stability on the Job and Documentation of Transfer to Extended Services"
              @clicked="onChangeTab"
              :currentStep="12"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="13">
            <EmploymentApplication
              v-if="e1 === 13"
              title="Employment Application"
              @clicked="onChangeTab"
              :currentStep="13"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="14">
            <EmploymentEligibility
              v-if="e1 === 14"
              title="Employment Eligibility Verification"
              @clicked="onChangeTab"
              :currentStep="14"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="15">
            <NonCompete
              v-if="e1 === 15"
              title="Non-Compete Agreement"
              @clicked="onChangeTab"
              :currentStep="15"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="16">
            <NonSolicitation
              v-if="e1 === 16"
              title="Non-Solicitation Agreement"
              @clicked="onChangeTab"
              :currentStep="16"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="17">
            <TrainingFee
              v-if="e1 === 17"
              title="Training Fee Deduction Authorization"
              @clicked="onChangeTab"
              :currentStep="17"
              :user="user"
            />
          </v-stepper-content>

           <v-stepper-content step="18">
            <PaycheckOption
              v-if="e1 === 18"
              title="Paycheck Options"
              @clicked="onChangeTab"
              :currentStep="18"
              :user="user"
            />
          </v-stepper-content>

           <v-stepper-content step="19">
            <PersonalResponsibilityPolicy
              v-if="e1 === 19"
              title="Personal Responsibility Policy"
              @clicked="onChangeTab"
              :currentStep="19"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="20">
            <ReportingPolicy
              v-if="e1 === 20"
              title="Reporting Policy"
              @clicked="onChangeTab"
              :currentStep="20"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="21">
            <MedicationProtocol
              v-if="e1 === 21"
              title="Medication Protocol"
              @clicked="onChangeTab"
              :currentStep="21"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="22">
            <RequiredCertifications
              v-if="e1 === 22"
              title="Acknowledgement of Required Certifications for Unsupervised Client Support"
              @clicked="onChangeTab"
              :currentStep="22"
              :user="user"
            />
          </v-stepper-content>

          <v-stepper-content step="23">
            <SmokingPolicy
              v-if="e1 === 23"
              title="Smoking Policy"
              @clicked="onChangeTab"
              :currentStep="23"
              :user="user"
            />
          </v-stepper-content>

            <v-stepper-content step="24">
            <VehiclePolicy
              v-if="e1 === 24"
              title="Vehicle Usage Policy"
              @clicked="onChangeTab"
              :currentStep="24"
              :user="user"
            />
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */

import { mapGetters, mapActions } from "vuex";

// New Hire Portal forms
import RuleAgreement from "./staff-form/rule-agreement";
import AcknowledgementOfContractUnderstanding from "./staff-form/acknowledgement-of-contract-understanding";
import PaycheckOption from "./staff-form/paycheck-option";
import AcknowledgementOfEmployeeHandbook from "./staff-form/acknowledgement-of-employee-handbook";
import AcknowledgementOfPolisophedureManual from "./staff-form/acknowledgment-of-polisophedure-manual";
import AwakePolicy from "./staff-form/awake-policy";
import CompanyHealthWellnessDentalAndVision from "./staff-form/company-health-wellness";
import RedheadSupportsJobDescription from "./staff-form/redhead-supports-job-description";
import FraternizationPolicy from "./staff-form/fraternization-policy";
import ExtremeBehaviorAwareness from "./staff-form/extreme-behavior-awareness";
import ClientTransportation from "./staff-form/client-transportation-agreement";
import ConfirmationExtended from "./staff-form/confirmation-extended";
import ConfirmationStability from "./staff-form/confirmation-stability";
import EmploymentApplication from "./staff-form/employment-application";
import EmploymentEligibility from "./staff-form/employment-eligibility";
import NonCompete from "./staff-form/non-compete-agreement";
import NonSolicitation from "./staff-form/non-solicitation";
import TrainingFee from "./staff-form/training-fee-deducation-authorization";
import PersonalResponsibilityPolicy from "./staff-form/personal-responsibility-policy";
import ReportingPolicy from "./staff-form/reporting-policy";
import MedicationProtocol from "./staff-form/medication-protocol";
import RequiredCertifications from "./staff-form/required-certifications";
import SmokingPolicy from "./staff-form/smoking-policy";
import VehiclePolicy from "./staff-form/vehicle-usage-policy";

export default {
  components: {
    RuleAgreement,
    AcknowledgementOfContractUnderstanding,
    AcknowledgementOfEmployeeHandbook,
    AcknowledgementOfPolisophedureManual,
    AwakePolicy,
    CompanyHealthWellnessDentalAndVision,
    RedheadSupportsJobDescription,
    FraternizationPolicy,
    ExtremeBehaviorAwareness,
    ClientTransportation,
    ConfirmationExtended,
    ConfirmationStability,
    EmploymentApplication,
    EmploymentEligibility,
    NonCompete,
    NonSolicitation,
    TrainingFee,
    PaycheckOption,
    PersonalResponsibilityPolicy,
    ReportingPolicy,
    MedicationProtocol,
    RequiredCertifications,
    SmokingPolicy,
    VehiclePolicy,
  },

  data() {
    return {
      e1: 1,
      steps: 1,
      stepperHeader: [
        "18/6 Rule Agreement",
        "Acknowledgement of Contract Understanding",
        "Acknowledgement of Receipt of Employee Handbook",
        "Acknowledgement of Receipt of Polisophedure Manual",
        "Awake Policy",
        "Company Health Wellness Dental and Vision",
        "RedheadSupportsJobDescription",
        "FraternizationPolicy",
        "ExtremeBehaviorAwareness",
        "Client Transportation",
        "Extended Service",
        "Confirmation of Stability",
        "Employment Application",
        "Eligibility Verification",
        "Non-Compete",
        "Non-Solicitation",
        "Training Fee",
        "Paycheck Option",
        "Personal Responsibility Policy",
        "Reporting Policy",
        "Medication Protocol",
        "Acknowledgement of Required Certifications for Unsupervised Client Support",
        "Smoking Policy",
        "Vehicle Usage Policy",
      ],
    };
  },

  created() {
  },

  computed: {
    ...mapGetters({
      user: "users/user",
      userCompany: "users/userCompany",
    }),
  },

  methods: {
    onChangeTab(value) {
      console.log(value)
      this.e1 = value;
    },
  },
};
</script>
